import dayjs from 'dayjs'
import { axiosClient } from './AxiosClient'

function listBookingLocation(page, size, searchKeyword, callback, errorCallback){
    let url = "/booking/location/list"
    const query = {
        page: page,
        size: size
    }
    if(searchKeyword !== ""){
        query["search_keyword"] = searchKeyword
    }

    axiosClient.get(url,{
        params: query
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createBookingLocation(locationName, detail, openTime, closeTime, repeat, locationImage, maxPeople, callback, errorCallback){
    let url = "/booking/location/create"

    var bodyForm = new FormData()
    bodyForm.append("location_name", locationName)
    bodyForm.append("detail", detail)
    bodyForm.append("start_operation", dayjs(openTime).valueOf())
    bodyForm.append("end_operation", dayjs(closeTime).valueOf())
    bodyForm.append("repeat", repeat)
    bodyForm.append("max_people_every_half_hour", maxPeople)
    if(locationImage){
        bodyForm.append("location_image", locationImage)
    }

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function editBookingLocation(locationId, locationName, detail, openTime, closeTime, repeat, locationImage, callback, errorCallback){
    let url = "/booking/location/edit"

    var bodyForm = new FormData()
    bodyForm.append("booking_location_id", locationId)
    bodyForm.append("location_name", locationName)
    bodyForm.append("detail", detail)
    bodyForm.append("start_operation", dayjs(openTime).valueOf())
    bodyForm.append("end_operation", dayjs(closeTime).valueOf())
    bodyForm.append("repeat", repeat)
    if(locationImage){
        bodyForm.append("location_image", locationImage)
    }

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteBookingLocation(locationId, callback, errorCallback){
    const url = "/booking/location/delete"
    var bodyForm = new FormData()
    bodyForm.append("location_id", locationId)
    axiosClient.post(url, bodyForm)
    .then((response)=>{ callback(response.data) })
    .catch((error) => errorCallback(error))
}

function getBookingLocationDetail(locationId, date, callback, errorCallback){
    let url = `/booking/location/get/${locationId}`
    const query = { }
    if(date){
        query["date"] = dayjs(date).format("MM/DD/YYYY")
    }
    axiosClient.get(url, { params: query })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function getUserInTimerange(timerangeId, date, callback, errorCallback){
    const url = "/booking/location/timerange/user"
    const query = {
        timerange_id: timerangeId,
        date: dayjs(date).format("MM/DD/YYYY")
    }
    axiosClient.get(url, { params: query })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function cancelBooking(bookingId, callback, errorCallback){
    const url = "/booking/cancel"
    var bodyForm = new FormData()
    bodyForm.append("booking_id", bookingId)
    axiosClient.post(url, bodyForm)
    .then((response)=>{ callback(response.data) })
    .catch((error) => errorCallback(error))
}

export { listBookingLocation, createBookingLocation, editBookingLocation, getBookingLocationDetail, getUserInTimerange, cancelBooking, deleteBookingLocation }